<div #divcontainer>
  <h2 [translate]="'widgets.teamMood.sprintOverview'">Project history</h2>

  <table class="contentTable">
    <tr>
      <td class="navigationColumn">
          <svg id="navigationSprintAvgLeft" class="nav-arrow" >
            <path d="M31.122 2.828L29.708 0L0 59.414L29.708 118.828L31.122 116L2.829 59.414L31.122 2.828Z"/>
          </svg>
      </td>
      <td class="contentColumn">
        <div class="content">
          <!-- Body -->
          <div class="canvasContainer">
            <canvas id="{{chartId}}"></canvas>
          </div>
        </div>
      </td>
      <td class="navigationColumn">
          <svg id="navigationSprintAvgRight" class="nav-arrow" >
            <path d="M-0.000175476 116L1.41383 118.828L31.1218 59.4141L1.41383 0.00012207L-0.000175476 2.82813L28.2928 59.4141L-0.000175476 116Z"/>
          </svg>
      </td>
  </table>
</div>
